import { motion } from "framer-motion";
import { REVIEWS, getStats } from "../data/reviews";
import Stars from "../components/Stars";

/**
 * Critics grid.  Handpicks the six most influential press notices —
 * five-star or byword-quality raves — laid out as a stark editorial grid.
 */
const PICKS = [
  { slug: "spy-city", outlet: "Soaked in Dreams" },
  { slug: "crooks-1926", outlet: "LondonTheatre1" },
  { slug: "crooks-1926", outlet: "BroadwayWorld" },
  { slug: "flicker", outlet: "LondonTheatre1" },
  { slug: "the-end", outlet: "LondonTheatre1" },
  { slug: "silence", outlet: "ScareTOUR" },
];

export default function Verdict() {
  const stats = getStats();
  const rows = PICKS.map((p) =>
    REVIEWS.find((r) => r.slug === p.slug && r.outlet === p.outlet),
  ).filter(Boolean);

  return (
    <section
      id="verdict"
      data-testid="home-verdict"
      className="section relative bg-[#050505] border-t border-white/10"
    >
      <div className="px-6 md:px-14 lg:px-20 xl:px-24 mb-20 md:mb-28 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-8">
          <div className="text-[10px] uppercase tracking-[0.35em] font-mono text-[#8b0000] mb-6">
            Best Immersive Theatre Reviews · London Press Verdict
          </div>
          <h2 className="bleed-h max-w-4xl text-white">
            Best immersive theatre reviews.
            <span className="block text-white/40">London press verdict.</span>
          </h2>
        </div>
        <div className="md:col-span-4 grid grid-cols-3 gap-6 text-white/70">
          <div>
            <div className="font-display text-3xl md:text-5xl text-white">
              {stats.total_reviews}
            </div>
            <div className="text-[10px] uppercase tracking-[0.3em] font-mono text-white/40 mt-2">
              Immersive Reviews
            </div>
          </div>
          <div>
            <div className="font-display text-3xl md:text-5xl text-white">
              {stats.rave_count}
            </div>
            <div className="text-[10px] uppercase tracking-[0.3em] font-mono text-white/40 mt-2">
              Rave Reviews
            </div>
          </div>
          <div>
            <div className="font-display text-3xl md:text-5xl text-white">
              {stats.outlet_count}
            </div>
            <div className="text-[10px] uppercase tracking-[0.3em] font-mono text-white/40 mt-2">
              London Outlets
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 md:px-14 lg:px-20 xl:px-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border border-white/10">
          {rows.map((r, i) => (
            <motion.a
              key={`${r.slug}-${r.outlet}-${i}`}
              href={r.url}
              target="_blank"
              rel="noreferrer"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              data-testid={`verdict-card-${i}`}
              className="group relative block p-8 md:p-10 border-b md:border-b border-r border-white/10 last:border-r-0 hover:bg-[#8b0000]/95 transition-colors duration-500"
            >
              <div className="flex items-center justify-between mb-8">
                <div className="text-[10px] uppercase tracking-[0.3em] font-mono text-white/60 group-hover:text-white/90">
                  {r.outlet}
                </div>
                {r.rating && <Stars value={r.rating} />}
              </div>
              <div className="font-display text-2xl md:text-3xl leading-tight text-white">
                “{r.quote}”
              </div>
              <div className="mt-8 flex items-center justify-between text-[10px] uppercase tracking-[0.3em] font-mono text-white/40 group-hover:text-white/80">
                <span>{r.show} · {r.year}</span>
                <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  Read →
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
